<template >
  <div class="ImageGallery" v-if="show">
    <div class="overlay" @click.prevent="close"></div>
    <div class="wrapper">
      <div class="gallery-header">
        <h3 v-if="gallery && gallery.title" v-html="gallery.title"></h3>
        <h3 v-else-if="data.gallery_title" v-html="data.gallery_title"></h3>
        <h3 v-else v-html="data.title"></h3>
        <p v-if="gallery && gallery.description" v-html="gallery.description"></p>
        <p v-else v-html="data.gallery_description"></p>
        
      </div>
      <div class="gallery-body">
        <div class="gallery-items">
          <transition
            name="fade"
            v-for="(item, index) in data.gallery"
            :key="index"
            class="gallery-item"
          >
            <img v-if="index == current" :src="item.large"
          /></transition>
        </div>
        <button class="gallery-prev" @click.prevent="prev">
          <span class="fa fa-chevron-left"></span>
        </button>
        <button class="gallery-next" @click.prevent="next">
          <span class="fa fa-chevron-right"></span>
        </button>
      </div>
      <div class="gallery-footer">
        <ul>
          <li
          class="pointer"
          @click.prevent="current = index"
            :class="{ active: index == current }"
            v-for="(item, index) in data.gallery"
            :key="index"
          >
            <div>
              <img v-if="item.thumb" :src="item.thumb" />
              <img v-else :src="item.large" />
            </div>
          </li>
        </ul>
        <button v-if="false && data.gallery && data.gallery.gallery > 6" class="gallery-prev">
          <span class="fa fa-chevron-left"></span>
        </button>
        <button v-if="false && data.gallery && data.gallery.gallery > 6" class="gallery-next">
          <span class="fa fa-chevron-right"></span>
        </button>
      </div>

      <button @click.prevent="close" class="gallery-close"><span class="fa fa-times"></span></button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ImageGallery",
  components: {},
  props: {
    data: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
    run: Function,
  },
  data: function () {
    return {
      current: 0,
    };
  },
  mounted: function () {},
  watch: {
    'data':function(){
        this.current = 0;
    }
  },

  computed: {
    gallery() {
      return this.data.gallery[this.current] ?? false;
    },
  },
  methods: {
    next() {
      let index = this.current + 1;
      if (index >= this.data.gallery.length) {
        index = 0;
      }
      this.current = index;
    },
    prev() {
      let index = this.current - 1;
      if (index < 0) {
        index = this.data.gallery.length - 1;
      }
      this.current = index;
    },
    close(){
        this.run('setRoot','galleryShow', false);
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
